import { createContext, useState, type Dispatch, type ReactNode, type SetStateAction } from 'react'

export type ChartType = 'line_chart' | '9_box_grid' | 'employee_pulse' | 'engagement_signals'

const ChartContext = createContext<
  [ChartType, Dispatch<SetStateAction<ChartType>>]
>(['line_chart', () => null])
type PromptProps = {
  children: ReactNode
}
const ChartProvider = ({ children }: PromptProps) => {
  const promptStateAndAction = useState<ChartType>('line_chart')

  return <ChartContext.Provider value={promptStateAndAction}>{children}</ChartContext.Provider>
}

export { ChartProvider }
